<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-btn
      icon
      slot="activator"
    >
      <v-icon color="error">delete</v-icon>
    </v-btn>
    <v-card>
      <v-card-title>
        <span class="headline">Branche löschen</span>
      </v-card-title>
      <v-card-text>
        Möchtest du die Branche "{{branch.title}}" wirklich löschen?
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" @click.native="del()" :loading="loading">Löschen</v-btn>
        <v-btn color="primary" @click.native="dialog = false">Abbrechen</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'DlgBranchDelete',
  components: {
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  props: ['branch'],
  methods: {
    ...mapActions({
      branchDel: 'branch/del',
      branchRead: 'branch/read',
    }),
    del() {
      this.loading = true;
      this.branchDel(this.branch).then((res) => {
        this.loading = false;
        if (res) {
          this.branchRead();
          this.dialog = false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
